import classes from '../create-schedule/CreateSchedule.module.scss';

interface HourProps {
  hourlyText: string;
}

export const HourlyComp = (props: HourProps) => {
  const { hourlyText } = props;

  return (
    <div className={classes['hours-align']} data-testid="hourText">
      {hourlyText}
    </div>
  );
};
